import styled, { css } from "styled-components";
import cloud from "@vitalsource/vstui/colors/cloud";
import { Accordion, AccordionButton, Caret } from "../../components/accordion";

const containerStyles = css`
  min-height: 62px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 500ms ease-in;
  &:hover {
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);
  }
  &.accordion-slide-enter {
    max-height: 62px;
  }

  &.accordion-slide-enter-active {
    max-height: 1000px;
  }

  &.accordion-slide-exit {
    max-height: 1000px;
  }

  &.accordion-slide-exit-active {
    max-height: 62px;
  }
`;

export const StyledAccordion = styled(Accordion)`
  ${containerStyles};
`;

export const StyledLikeAccordion = styled.div`
  ${containerStyles};
`;

const buttonStyles = css`
  background-color: #ffffff;
  min-height: 58px;
  border: none;
  width: 100%;
  font-weight: 500;
  font-size: 1.6rem;
  color: ${cloud.getShade(10)};
  text-align: left;
  padding: 12px 15px 10px 15px;
  display: flex;
  align-items: center;
  &.archived {
    color: ${cloud.getShade(7)};
    font-weight: 300;
  }
`;

export const StyledAccordionButton = styled(AccordionButton)`
  ${buttonStyles};
`;

export const StyledLikeAccordionButton = styled.a`
  ${buttonStyles};
`;

export const StyledCaret = styled(Caret)`
  margin-right: 19px;
`;

export const PieChartWrapper = styled.a`
  display: block;
  height: 34px;
  margin-left: auto;
  position: relative;
  width: 34px;
`;
